class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.productInfoContainer = document.querySelector('inline-modal-dialog');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    if (this.productInfoContainer) {
      this.productInfoContainer.classList.add('active');
    }
    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    
    if (this.productInfoContainer) {
      this.productInfoContainer.classList.remove('active');
      if (this.productInfoContainer.hasAttribute('open')) {
        this.productInfoContainer.hide();
      }
    }
    
    // 延迟移除焦点陷阱，避免干扰其他 UI 元素的打开
    setTimeout(() => {
      removeTrapFocus(this.activeElement);
    }, 100);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    
    // 如果是 "View cart" 按钮或其他购物车相关元素，不处理
    if (target.closest('.cart-notification_button') || 
        target.closest('cart-drawer') ||
        target.classList.contains('view-cart')) {
      return;
    }
    
    if (target !== this.notification && !target.closest('cart-notification')) {
       if (target.closest('.cart-notification-product-recommendations_container')) {
           return;
        }
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);

function openCartDrawer() {
  // 关闭 cart-notification
  const cartNotification = document.querySelector('cart-notification');
  if (cartNotification && typeof cartNotification.close === 'function') {
    cartNotification.close();
  }
  
  // 关闭 inline-modal-dialog
  const inlineModalDialog = document.querySelector('inline-modal-dialog[open]');
  if (inlineModalDialog && typeof inlineModalDialog.hide === 'function') {
    inlineModalDialog.hide();
  }
  
  // 打开 cart-drawer
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && typeof cartDrawer.open === 'function') {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartDrawer.open(cartLink);
  } else {
    // 如果没有 cart-drawer，跳转到购物车页面
    window.location.href = '/cart';
  }
}
